<script>
  import Navbar from "./Components/Navbar/Navbar.svelte";
  import Banner from "./Components/Banner/Banner.svelte";
  import Services from "./Components/Services/Services.svelte";
  import About from "./Components/About/About.svelte";
  import Testimonials from "./Components/Testimonials/Testimonials.svelte";
  import Social from "./Components/Social/Social.svelte";
  import Footer from "./Components/Footer/Footer.svelte";
  import Timeline from "./Components/Timeline/Timeline.svelte";
  import { onMount } from 'svelte';

  import DATA from "./Data/data";
  console.log(DATA);

  import posts from "./Data/timelinePostingsData";
  console.log(posts);
 
</script>

<!-- Note: posts data was originally beiong obtained using fetch:  fetch('https://jsonplaceholder.typicode.com/comments')  -->
<!--   As in Florian Raffl's svelte-twitter app.  -->

<!-- Navbar -->
<Navbar navlists={DATA.NAVBAR_DATA} header={DATA.HEADER} />

<!-- Banner -->
<Banner bannerData={DATA.BANNER_DATA}  />

<!-- Services -->
<!-- <Services serviceData={DATA.SERVICE_DATA} /> -->

<!-- About -->
<!-- <About aboutData={DATA.ABOUT_DATA} /> -->

<!-- Testimonials -->
<!--  <Testimonials testimonialData={DATA.TESTIMONIAL_DATA} /> -->

<!-- Timeline -->
<div class="container">
  <div class="row">
    {#if posts === undefined}
      <b>Loading posts ...</b>
    {:else if posts instanceof Error}
      <span style="color: red">There was an error encountered while loading the postings data.</span>
    {:else}
      <Timeline posts={posts} />
    {/if}
  </div>
</div>

<!-- Social Media -->
<Social socialData={DATA.SOCIAL_DATA} />

<!-- Footer -->
<Footer footerData={DATA.FOOTER_DATA} header={DATA.HEADER} />
